import React from 'react';
import { useTimezone } from '@uplift/contexts';
import { CalendarDateService } from '@uplift/services';
import { CustomStartTimeSelect } from './CustomStartTimeSelect.component';
import { DateFormats } from '@uplift/constants';
import { ProviderMedicalRole } from '@uplift/types';


const filterSlotsByDuration = (medicalRole: ProviderMedicalRole, slots: Set<string>, appointmentDuration: number) => {
  const slotMinutesDuration = {
    [ProviderMedicalRole.therapist]: 15,
    [ProviderMedicalRole.psychiatrist]: 5,
  }[medicalRole];

  const durationSlotsCount = appointmentDuration / slotMinutesDuration;

  return Array.from(slots).filter(slot => {
    const slotObj = CalendarDateService.date.utc(slot);

    for (let i = 0; i < durationSlotsCount; i++) {
      const nextSlot = slotObj.add(i * slotMinutesDuration, 'minutes').format(DateFormats.ISODayjs);

      if (!slots.has(nextSlot)) {
        return false;
      }
    }

    return true;
  });
};


export type StartTimeSelectProps = {
  name: string;
  label?: string;
  appointmentDuration: number;
  textOnly?: boolean;
  slots: Set<string>;
  medicalRole: ProviderMedicalRole;
};


export const StartTimeSelect: React.VFC<StartTimeSelectProps> = ({ slots, medicalRole, ...props }) => {
  const timezone = useTimezone();
  const availableSlots = React.useMemo(() => {
    if (!slots) {
      return [];
    }

    return filterSlotsByDuration(medicalRole, slots, props.appointmentDuration);
  }, [ medicalRole, slots, props.appointmentDuration ]);
  const options = React.useMemo(() => {
    return availableSlots.map((slot) => {
      const val = CalendarDateService.date(slot).tz(timezone);
      const formattedLabel = val.format('h:mma');
      const formattedValue = val.format(DateFormats.ISODayjs);

      return {
        value: formattedValue,
        label: formattedLabel,
      };
    });
  }, [ availableSlots, timezone ]);

  return (
    <CustomStartTimeSelect
      {...props}
      items={options}
    />
  );
};
